import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
/** Dark panel: 28px corners, rises in on first show (D49). */
export function Card({ className, ...rest }) {
    return _jsx("div", { className: cn("glass animate-rise rounded-card p-4 sm:p-6", className), ...rest });
}
export function CardTitle({ className, ...rest }) {
    return _jsx("h2", { className: cn("font-heading text-lg font-semibold text-fg", className), ...rest });
}
//# sourceMappingURL=Card.js.map